'use client';

import * as React from 'react';
import LayoutOverlay from '@/components/ui/LayoutOverlay';
import Overlay from '@/components/ui/Overlay';
import { useOverlay } from '@/components/hooks/useOverlay';
import Button from '@/components/ui/Button';
import Block from '@/components/ui/Block';
import Buttons from '@/components/ui/Buttons';
import { Overlays } from '@/components/ui/Overlays';
import Ticket from '@/components/ui/Ticket';
import { useTranslations } from '@/lib/hooks/useTranslations';
import { useRouter } from 'next/navigation';
import { OverlayPurchaseTicketsSuccessMeta } from '@/components/overlays/overlays';

const OverlayPurchaseSuccessClient: React.FunctionComponent = () => {
  const { closeOverlay, isOverlayOpen, overlayMeta } = useOverlay<OverlayPurchaseTicketsSuccessMeta>(`purchase-success`);
  const { ns, ticketAmount, ticket } = overlayMeta;
  const t = useTranslations(`OverlayPurchaseSuccess`, ns);
  const { overlaysActions } = React.useContext(Overlays);
  const router = useRouter();

  return (
    <Overlay
      isOpen={isOverlayOpen}
      onClose={closeOverlay}
      layout="default"
      hideClose={true}
      confetti={true}
    >
      <LayoutOverlay
        size="small"
        header={{
          addOn: (
            <Ticket
              imageUrl={ticket.image}
              imageAlt={ticket.label}
              amount={`+${ticketAmount}`}
            />
          ),
          title: t('purchaseConfirmedTitle'),
          align: 'center',
        }}
        theme="success"
      >
        <Block>
          <p className="font-size-large normal align-center">
            {t('successTextDetails {{count}} {{ticketType}}', {
              count: ticketAmount,
              ticketType: ticket.label,
            })}
          </p>
          <Buttons layout="centered">
            <Button
              title={t('btnClose')}
              theme="primary"
              onClick={() => {
                overlaysActions({
                  action: 'close',
                  name: 'all',
                });
                router.refresh();
              }}
            />
          </Buttons>
        </Block>
      </LayoutOverlay>
    </Overlay>
  );
};

OverlayPurchaseSuccessClient.displayName = 'OverlayPurchaseSuccessClient';

export default OverlayPurchaseSuccessClient;
